<template>
    <section class="airport-faq airport-page-section">
        <div class="airport-faq__container">
            <h2 class="airport-faq__title airport-page-title">{{ blok.title }}</h2>
            <div class="airport-faq__list">
                <div
                    v-for="(item, index) in blok.accordionList"
                    :key="item._uid"
                    class="accordion-item"
                    :class="{
                        'is-open': currentSelected === index,
                    }"
                >
                    <div class="accordion-item__header" @click="toggleItem(index)">
                        <h3>{{ item.title }}</h3>
                        <i data-icon="true" class="accordion-item__icon"></i>
                    </div>
                    <RichText
                        :richtext="item.text"
                        class="accordion-item__content"
                        :class="{ open: currentSelected === index }"
                    />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import type { IL4AirportAccordion } from '~/types';

defineProps<{ blok: IL4AirportAccordion }>();

const currentSelected = ref();

function toggleItem(index) {
    currentSelected.value = index !== currentSelected.value ? index : null;
}
</script>

<style lang="postcss" scoped>
.airport-faq {
    &__container {
        @apply md:container;
    }
    &__title {
        @apply mb-8;
    }
    &__list {
        @apply border-b border-gray-200;
    }
}

.accordion-item {
    &__header {
        @apply flex justify-between items-center py-3 border-t border-gray-200 cursor-pointer font-semibold;
    }
    &__icon {
        @apply block h-6 w-6 bg-cover;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='25' viewBox='0 0 24 25' fill='none'%3E%3Cg clip-path='url(%23clip0_122_85621)'%3E%3Cpath d='M12.0007 13.6727L16.9507 8.72266L18.3647 10.1367L12.0007 16.5007L5.63672 10.1367L7.05072 8.72266L12.0007 13.6727Z' fill='%23180B1E'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_122_85621'%3E%3Crect width='24' height='24' fill='white' transform='translate(0 0.5)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E");
        .is-open & {
            @apply rotate-180;
        }
    }
    &__content {
        @apply max-h-[0px] border-gray-200 overflow-hidden;
        transition:
            max-height 0.2s,
            padding 0.2s;
        .is-open & {
            @apply py-4 max-h-[1000px] border-t border-gray-200;
        }
        :deep(p:not(:last-child)) {
            @apply mb-4;
        }
        :deep(a) {
            @apply text-[#0094FF] hover:underline hover:text-[#0084E3];
        }
    }
}
</style>
